import {
  PaymentConfigs,
  PaymentStatus,
} from "@portal/types/entities/payment";

const paymentConfig: PaymentConfigs = {
  statusConfig: {
    VOID: {
      label: "Void",
      style: {
        borderColor: "var(--volcano-1)",
        backgroundColor: "var(--volcano-1)",
        textColor: "var(--volcano-6)",
      },
    },
    UNAPPLIED: {
      label: "Unapplied",
      style: {
        borderColor: "var(--red-1)",
        backgroundColor: "var(--red-1)",
        textColor: "var(--red-6)",
      },
    },
    FULLY_APPLIED: {
      label: "Fully Applied",
      style: {
        borderColor: "var(--green-1)",
        backgroundColor: "var(--green-1)",
        textColor: "var(--green-6)",
      },
    },
    PARTIALLY_APPLIED: {
      label: "Partially Applied",
      style: {
        borderColor: "var(--orange-1)",
        backgroundColor: "var(--orange-1)",
        textColor: "var(--orange-6)",
      },
    },
    APPLIED: {
      label: "Applied",
      style: {
        borderColor: "var(--green-1)",
        backgroundColor: "var(--green-1)",
        textColor: "var(--green-6)",
      },
    },
  },
};

export function getPaymentStatus(status: PaymentStatus) {
  return paymentConfig.statusConfig[status];
}
export function getPaymentModeLabel(mode?: string) {
  return mode ?? '-';
}
